import { Component, HostBinding } from '@angular/core';
import { theme } from '../../../../../data/theme';
import { ApiService } from '../../../../service/api.service'
@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent {
    @HostBinding('class.footer-contacts') classFooterContacts = true;

    theme = theme;
    data:any;

    constructor(
        private service : ApiService
    ) {
        this.loadData();
     }

    loadData(){
        this.service.getWebsiteDetail().subscribe((res:any) =>{
            this.data = res[0]
        })
    }
}
